// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    SendEnrollmentRequestModel,
    SendReminderRequestModel,
    TransientEzScriptSendEnrollmentResponse,
    TransientEzScriptSendReminderResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeTransientApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param sendEnrollmentRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async ezScriptSendEnrollment (sendEnrollmentRequestModel: SendEnrollmentRequestModel, xProgramId?: string): Promise<AxiosResponse<TransientEzScriptSendEnrollmentResponse>> {
        const _url_ = '/edge/transient/ezScript/sendEnrollment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'sendEnrollmentRequestModel' is not null or undefined
        if (sendEnrollmentRequestModel === null || sendEnrollmentRequestModel === undefined) {
            throw new Error('Required parameter sendEnrollmentRequestModel was null or undefined when calling ezScriptSendEnrollment.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(sendEnrollmentRequestModel, "SendEnrollmentRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TransientEzScriptSendEnrollmentResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TransientEzScriptSendEnrollmentResponse");
        }
        return response;
    }
    /**
     * 
     * @param sendReminderRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async ezScriptSendReminder (sendReminderRequestModel: SendReminderRequestModel, xProgramId?: string): Promise<AxiosResponse<TransientEzScriptSendReminderResponse>> {
        const _url_ = '/edge/transient/ezScript/sendReminder';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'sendReminderRequestModel' is not null or undefined
        if (sendReminderRequestModel === null || sendReminderRequestModel === undefined) {
            throw new Error('Required parameter sendReminderRequestModel was null or undefined when calling ezScriptSendReminder.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(sendReminderRequestModel, "SendReminderRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TransientEzScriptSendReminderResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TransientEzScriptSendReminderResponse");
        }
        return response;
    }
}
